import React from "react";
const YellowBall_Poceada = ({ size }) => {
   return (
    <svg
      width={size ?? "70"}
      height={size ?? "70"}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="35" cy="35" r="35" fill="url(#yellowGradient)" />

      <defs>
        <radialGradient
          id="yellowGradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35 35) scale(35)"
        >
          <stop offset="0%" stopColor="#FFFDC1" />
          <stop offset="60%" stopColor="#F2EC59" />
          <stop offset="100%" stopColor="#FDC20C" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default YellowBall_Poceada;
